<template>
  <div
    class="question-display-item mb-3 border-bottom pb-2"
    :class="[answerClass, itemClasses]"
  >
    <div class="d-flex justify-content-between align-items-center">
      <h6 class="font-weight-bold mb-0">
        {{ displayNumber }}{{ question.name }}
        <b-badge
          v-if="question.answer && question.answer.isCorrect === true"
          variant="success"
          class="answer-badge ms-2"
        >
          <b-icon
            icon="check-circle-fill"
            class="me-1 readable-badge-content"
          ></b-icon
          ><span class="readable-badge-content">Sí</span>
        </b-badge>
        <b-badge
          v-else-if="question.answer && question.answer.isCorrect === false"
          variant="danger"
          class="answer-badge ms-2"
        >
          <b-icon
            icon="x-circle-fill"
            class="me-1 readable-badge-content"
          ></b-icon
          ><span class="readable-badge-content">No</span>
        </b-badge>
      </h6>
    </div>

    <b-collapse
      :id="`details-collapse-qdisplay-${question.id}-${itemIndex}-${depth}`"
      :visible="question.answer && question.answer.isCorrect === true"
    >
      <div class="mt-2 mb-2 ps-3">
        <SocietyTable
          :questionName="''"
          :societies="question.answer.questionSocieties || []"
          :fieldNameCargo="question.fieldNameCargo || 'Cargo'"
          :fieldNameDate="question.fieldNameDate || 'Periodo'"
        ></SocietyTable>
      </div>
    </b-collapse>

    <b-collapse
      :id="`subquestions-collapse-qdisplay-${question.id}-${itemIndex}-${depth}`"
      :visible="
        question.answer &&
        question.answer.isCorrect === true &&
        question.childrenQuestions &&
        question.childrenQuestions.length > 0
      "
    >
      <div class="mt-2 mb-2 ps-3">
        <div class="border-start">
          <PepQuestionDisplay
            v-for="(childQuestion, index) in question.childrenQuestions"
            :key="childQuestion.id"
            :question="childQuestion"
            :depth="depth + 1"
            :itemIndex="index"
            :parentNumberString="displayNumber"
          />
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import SocietyTable from "@/components/shared/Statements/Society-table.vue";

export default {
  name: "PepQuestionDisplay",
  components: {
    SocietyTable,
  },
  computed: {
    answerClass() {
      if (this.question.answer) {
        if (this.question.answer.isCorrect === true) {
          return "answer-correct";
        }
        return "answer-incorrect";
      }
      return "answer-neutral";
    },
    itemClasses() {
      if (this.depth === 0) {
        return "top-level-question";
      }
      return "sub-question-item pt-1 pb-1";
    },
    displayNumber() {
      const currentNum = this.itemIndex + 1;
      if (this.parentNumberString) {
        return `${this.parentNumberString}${currentNum}. `;
      }
      return `${currentNum}. `;
    },
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 0,
    },
    itemIndex: {
      type: Number,
      required: true,
    },
    parentNumberString: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.question-display-item {
  background-color: #f8f9fa;
}

.question-display-item.top-level-question {
  background-color: transparent;
}

.answer-badge {
  padding: 0.3em 0.6em;
  font-size: 0.9em;
  vertical-align: middle;
}

.readable-badge-content {
  color: #212529;
}

.question-display-item .border-start {
  border-left-width: 3px;
  border-color: #6c757d;
  padding-left: 1rem;
}

.question-display-item.answer-correct .border-start {
  border-color: #28a745;
}
.question-display-item.answer-incorrect .border-start {
  border-color: #dc3545;
}
.question-display-item.answer-neutral .border-start {
  border-color: #6c757d;
}
</style>
